import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './SearchResults.css'; // Import the new CSS file

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const API_URL = process.env.REACT_APP_API_URL;

export default function SearchResults() {
  const query = useQuery();
  const searchTerm = query.get('s') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!searchTerm) return;
    setLoading(true);
    fetch(`${API_URL}/api/search?s=${encodeURIComponent(searchTerm)}`)
      .then(res => res.json())
      .then(data => {
        setResults(data);
        setLoading(false);
      });
  }, [searchTerm]);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <section className="search-results-page-wrapper" aria-labelledby="search-results-main-heading">
      <h2 id="search-results-main-heading" className="search-results-heading">Search Results for "{searchTerm}"</h2>
      {loading && <p>Loading...</p>}
      {!loading && results.length === 0 && <p>No results found.</p>}
      <div className="results-grid">
        {results.map(result => (
          <div className="result-tile" key={result.id}>
            {result.type === 'page' ? (
              <>
                <Link to={result.url}><h3>{result.title}</h3></Link>
                <span>Site Page</span>
                <p>{result.excerpt}</p>
                <Link to={result.url}><button>Go to Page</button></Link>
              </>
            ) : (
              <>
                <Link to={result.url}><h3>{result.title}</h3></Link>
                <span>{result.date}</span>
                <p>{result.excerpt}</p>
                <Link to={result.url}><button>Read More</button></Link>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
} 